import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

// import { TextMaskModule } from 'angular2-text-mask';
import { NgxMaskDirective } from 'ngx-mask';
import { PipesModule } from '@app/components/pipes/pipes.module';
import { AngularMaterialModule } from '../angular-material/angular-material.module';
import { ToolsModule } from '../tools/tools.module';
import { RecaptchaModule, RecaptchaFormsModule } from "ng-recaptcha-2";

import { CarouselModule } from 'ngx-owl-carousel-o';

import { InnerPageNavSectionComponent } from './inner-page-nav-section/inner-page-nav-section.component';
import { ThreeThumbnailSectionComponent } from './three-thumbnail-section/three-thumbnail-section.component';
import { ApplicantFormComponent } from './applicant-form/applicant-form.component';
import { AttractionCarouselComponent } from './attraction-carousel/attraction-carousel.component';
import { JobsNearbyCarouselComponent } from './jobs-nearby-carousel/jobs-nearby-carousel.component';
import { HotMarketCarouselComponent } from './hot-market-carousel/hot-market-carousel.component';
import { CustomEduChatWindowComponent } from './custom-edu-chat-window/custom-edu-chat-window.component';
import { JobsNearbyListComponent } from './jobs-nearby-list/jobs-nearby-list.component';
import { JobsByMarketsComponent } from './jobs-by-markets/jobs-by-markets.component';
import { ProfessionCardsComponent } from './profession-cards/profession-cards.component';
import { ReviewsCarouselComponent } from './reviews-carousel/reviews-carousel.component';
import { ApplyFormWithProfessionComponent } from './apply-form-with-profession/apply-form-with-profession.component'
import { ServicesCarouselComponent } from './services-carousel/services-carousel.component';
import { AmazingCareerScrollingImageBgComponent } from './amazing-career-scrolling-image-bg/amazing-career-scrolling-image-bg.component';
import { PhoneValidatorMaskDirective } from '../directives/phone-validator-mask.directive';
import { ZipValidatorMaskDirective } from '../directives/zip-validator-mask.directive';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule,
        RecaptchaModule,
        RecaptchaFormsModule,
        CarouselModule,
        PhoneValidatorMaskDirective,
        ZipValidatorMaskDirective,
        // TextMaskModule,
        NgxMaskDirective,
        PipesModule,
        AngularMaterialModule,
        ToolsModule
    ],
    declarations: [
        AmazingCareerScrollingImageBgComponent,
        InnerPageNavSectionComponent,
        ThreeThumbnailSectionComponent,
        ApplicantFormComponent,
        ApplyFormWithProfessionComponent,
        AttractionCarouselComponent,
        JobsNearbyCarouselComponent,
        HotMarketCarouselComponent,
        ServicesCarouselComponent,
        CustomEduChatWindowComponent,
        JobsNearbyListComponent,
        JobsByMarketsComponent,
        ProfessionCardsComponent,
        ReviewsCarouselComponent
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    exports: [
        AmazingCareerScrollingImageBgComponent,
        InnerPageNavSectionComponent,
        ThreeThumbnailSectionComponent,
        ApplicantFormComponent,
        ApplyFormWithProfessionComponent,
        AttractionCarouselComponent,
        JobsNearbyCarouselComponent,
        HotMarketCarouselComponent,
        CustomEduChatWindowComponent,
        JobsNearbyListComponent,
        JobsByMarketsComponent,
        ProfessionCardsComponent,
        ReviewsCarouselComponent,
        ServicesCarouselComponent
    ]
})
export class PublicWidgetsModule { }
